import { Component, Inject, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

@Component({
  selector: "app-scorecard-modal",
  templateUrl: "./scorecard-modal.component.html",
  styleUrls: ["./scorecard-modal.component.scss"],
})
export class ScorecardModalComponent implements OnInit {
  vendorId: any;

  constructor(
    public readonly dialogRef: MatDialogRef<ScorecardModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit(): void {
    this.vendorId = this.data.vendorId;
  }

  closeModal(bool = false): void {
    this.dialogRef.close(bool);
  }
}
